import React from "react";
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";

interface FeedbackSelectionProps {
  questionId: number;
  feedbackValue: number | undefined;
  handleFeedbackChange: (feedbackfrageID: number, bewertung: number) => void;
  questionAnswered: (questionID: number) => boolean;
  checkAnswered: boolean;
}

/**
 * Displays the feedback options
 * @returns The FeedbackSelection component
 */
const FeedbackSelection: React.FunctionComponent<FeedbackSelectionProps> = ({
  questionId,
  feedbackValue,
  handleFeedbackChange,
  questionAnswered,
  checkAnswered,
}) => {
  // Function to handle the feedback change
  const handleChange = (event: SelectChangeEvent<number>) => {
    const newValue = event.target.value as number;
    handleFeedbackChange(questionId, newValue);
  };

  const answered = checkAnswered && !questionAnswered(questionId);

  return (
    <FormControl size="small" sx={{ width: 150 }} error={answered}>
      <InputLabel>Bewertung</InputLabel>
      <Select label="Bewertung" value={feedbackValue} onChange={handleChange}>
        <MenuItem value={1}>1</MenuItem>
        <MenuItem value={2}>2</MenuItem>
        <MenuItem value={3}>3</MenuItem>
        <MenuItem value={4}>4</MenuItem>
        <MenuItem value={5}>5</MenuItem>
        <MenuItem value={6}>6</MenuItem>
        <MenuItem value={0}>Keine Angabe</MenuItem>
      </Select>
    </FormControl>
  );
};

export default FeedbackSelection;
